<mat-chip
    [disabled]="!isMostRecentFilter && addedFilterLength > 1"
    [ngClass]="{ disabled: !isMostRecentFilter && addedFilterLength > 1 }"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="selectionMenu"
    (click)="onFilterClick()">
    <mat-icon class="remove_filter_icon" matChipRemove (click)="removeFilter()"
        >cancel
    </mat-icon>
    <div class="normal_text">
        <ng-container *ngIf="selectedOption; else defaultLabel">
            {{ selectedOption.heading }}
        </ng-container>

        <ng-template #defaultLabel>
            {{ filter.name }}
        </ng-template>
    </div>
    <mat-icon class="toolbar_icon_colour"> arrow_drop_down </mat-icon>
</mat-chip>

<mat-menu #selectionMenu="matMenu" #matMenu="matMenu" class="user_menu">
    <div class="search_task_item_container">
        <input
            autocomplete="off"
            (click)="$event.stopPropagation()"
            [formControl]="search"
            id="task_menu_search"
            mat-menu-item
            matInput
            placeholder="Search" />
        <div class="search-box-spinner" *ngIf="dataLoading">
            <mat-spinner [diameter]="20"></mat-spinner>
        </div>
    </div>

    <div [ngSwitch]="filter.filterOptionType">
        <ng-container *ngSwitchCase="dataTypeEnum.HeadingAndSubheading">
            <ng-container *ngIf="data?.length > 0; else empty">
                <button
                    *ngFor="let option of data"
                    mat-menu-item
                    (click)="selectOption(option)">
                    <div class="user_task_profile menu client-section">
                        <div class="client-text client-id">
                            {{ option.subheading }}
                        </div>
                        <div class="client-text client-name">
                            {{ option.heading }}
                        </div>
                    </div>
                </button>
            </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="dataTypeEnum.HeadingOnly">
            <ng-container *ngIf="data?.length > 0; else empty">
                <button
                    *ngFor="let option of data"
                    mat-menu-item
                    (click)="selectOption(option)">
                    <div class="user_task_profile menu client-section">
                        <div class="client-text client-name">
                            {{ option.heading }}
                        </div>
                    </div>
                </button>
            </ng-container>
        </ng-container>
    </div>
</mat-menu>

<ng-template #empty>
    <ng-container *ngIf="data != undefined && data != null">
        <div class="empty-results-wrapper">
            <span>No results found</span>
        </div>
    </ng-container>
</ng-template>
